<header>
    <div class="side-menu">
        <h1 class="navbar-brand">
            <a routerLink="/list-va" tabindex="1">
                <img src="assets/images/logo.svg" alt="logo" (click)="clearProjectCache()" />
            </a>
        </h1>
        <div class="menu-wrapper" >
            <app-sidebar></app-sidebar>
        </div>
        <div class="info">
           


          <span class=" trash-box-btn" [class.active]="trashStatus" tabindex="3">
            <a  routerLink="/trash" class="btn"><i class="icon-delete-garbage-streamline" ngbTooltip="Trash"></i></a>
          </span>
                
    
                 <span class="help" tabindex="6">
            <a href="javascript:void(0)" (click)="newFeedback()" placement="top" ngbTooltip="Feedback">
              <i class="icon-chat"></i>
            </a>
          </span> 
            </div>
        </div>
   
</header>